import { SingleChoiceEditComponent } from './edit';
import { SingleChoicePreviewComponent } from './preview';
import { SingleChoiceAiChangePreviewComponent } from './ai-change-preview';
import { SingleChoiceGradingComponent } from './grading/single-choice-grading.component';
import { SingleChoiceReportComponent } from './report/single-choice-report.component';
import { SingleChoiceAnswerComponent } from './answer';
export var SINGLE_CHOICE_REGISTRY = {
  edit: SingleChoiceEditComponent,
  preview: SingleChoicePreviewComponent,
  'ai-change-preview': SingleChoiceAiChangePreviewComponent,
  grading: SingleChoiceGradingComponent,
  report: SingleChoiceReportComponent,
  answer: SingleChoiceAnswerComponent
};